/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
/* eslint-disable max-len */

import { Copy, Edit2, MoreHorizontal, Trash } from 'lucide-react';
import { Dispatch, FC, useState } from 'react';

import { Step } from './LiveAgentTypes';

import { Command, CommandGroup, CommandItem, CommandList } from '@/components/ui/command';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

export const StepContextualMenu: FC<{
    index: number;
    parentIndex?: number;
    step: Step;
    dispatch: Dispatch<any>;
    removeStep?: (step: Step, index: number, parentIndex?: number) => void;
    updateOpenStep?: (stepId: string, force?: boolean) => void;
}> = ({ dispatch, index, parentIndex, step, removeStep, updateOpenStep }) => {
    const [open, setOpen] = useState(false);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <button className="ms-auto" aria-label="More actions">
                    <MoreHorizontal className="text-slate-400" size="24px" />
                </button>
            </PopoverTrigger>
            <PopoverContent className="w-[200px] p-0">
                <Command>
                    <CommandList>
                        <CommandGroup>
                            <CommandItem
                                onSelect={() => {
                                    dispatch({
                                        type: 'duplicate',
                                        payload: { index },
                                    });
                                }}
                            >
                                <div className="flex items-center gap-2">
                                    <Copy className="text-slate-500" width="16px" height="16px" />
                                    {step.kind !== 'block' ? 'Duplicate step' : 'Duplicate block'}
                                </div>
                            </CommandItem>
                            {step.kind !== 'block' && (
                                <CommandItem
                                    onSelect={() => {
                                        updateOpenStep?.(step.id, true);
                                        dispatch({
                                            type: 'update',
                                            payload: {
                                                id: step.id,
                                                data: {
                                                    executed: false,
                                                    actions: null,
                                                    recorded: null,
                                                },
                                            },
                                        });
                                    }}
                                >
                                    <div className="flex items-center gap-2">
                                        <Edit2 className="text-slate-500" width="16px" height="16px" />
                                        Edit step
                                    </div>
                                </CommandItem>
                            )}
                            {removeStep && (
                                <CommandItem onSelect={() => removeStep(step, index, parentIndex)}>
                                    <div className="flex items-center gap-2">
                                        <Trash className="text-slate-500" width="16px" height="16px" />
                                        {step.kind !== 'block' ? 'Delete step' : 'Delete block'}
                                    </div>
                                </CommandItem>
                            )}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
};
